<template>
  <div>
    <div class="common-form">营业执照</div>

    <el-form-item label="营业执照">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image','licence_image')">选择图片</el-button>
        <div v-if="form.waiter.licence && form.waiter.licence.certificate!=''" class="img">
          <img :src="form.waiter.licence.certificate" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>
    <div class="common-form">职称资质</div>
    <el-form-item label="职业资格证" prop="waiter.aptitude.certificate">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image','aptitude_image')">选择图片</el-button>
        <div v-if="form.waiter.aptitude && form.waiter.aptitude.certificate!=''" class="img">
          <img :src="form.waiter.aptitude.certificate" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>
    <div class="common-form">健康证</div>
    <el-form-item label="健康证证明" prop="waiter.health.certificate">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image','health_image')">选择图片</el-button>
        <div v-if="form.waiter.health && form.waiter.health.certificate!=''" class="img">
          <img :src="form.waiter.health.certificate" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>
    <div class="common-form">无犯罪证明</div>
    <el-form-item label="无犯罪证明" prop="waiter.nocrime.certificate">
      <el-row>
        <el-button type="primary" @click="openProductUpload('image','nocrime_image')">选择图片</el-button>
        <div v-if="form.waiter.nocrime && form.waiter.nocrime.certificate!=''" class="img">
          <img :src="form.waiter.nocrime.certificate" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>

    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },

  data() {
    return {
      isProductUpload: false,
      config: {},
      file_name: "image"
    };
  },
  inject: ["form"],
  mounted() {},
  computed: {},
  methods: {
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "licence_image") {
          this.form.waiter.licence.certificate = e[0].filePath;
        } else if (this.file_name == "aptitude_image") {
          this.form.waiter.aptitude.certificate = e[0].filePath;
        } else if (this.file_name == "health_image") {
          this.form.waiter.health.certificate = e[0].filePath;
        } else if (this.file_name == "nocrime_image") {
          this.form.waiter.nocrime.certificate = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/occupation.vue